import { render, staticRenderFns } from "./SubmitQuestionForm.vue?vue&type=template&id=48018f10"
import script from "./SubmitQuestionForm.vue?vue&type=script&lang=js"
export * from "./SubmitQuestionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports